import React from 'react';
import { bool, string, func } from 'prop-types';
import IconArrowDown from '../../images/contract-admin-icons/IconArrowDown';
import IconArrowUp from '../../images/contract-admin-icons/IconArrowUp';

const TableHeaderButton = ({
  label,
  isDisabled,
  sortOrder,
  sortColumn,
  isActive,
  onClick,
}) => {
  return (
    <button
      data-test="tableHeaderButtonTest"
      type="button"
      className="ca--table__col--root"
      disabled={isDisabled}
      onClick={() => onClick(label, sortColumn)}
    >
      <span>{label}</span>
      <span className="ca--sort__icon ca--sort__icon--down" />
      {isActive && sortOrder === 'desc' && <IconArrowDown />}
        {isActive && sortOrder === 'asc' && <IconArrowUp />}

    </button>
  );
};

TableHeaderButton.propTypes = {
  label: string,
  isDisabled: bool,
  sortOrder: string,
  sortColumn: string,
  onClick: func,
  isActive: bool,
};

export default TableHeaderButton;
